<template>
  <b-container fluid class="mt-50">
    <b-row class="justify-content-end pb-4" v-if="isAdmin">
      <b-col cols="12" md="3" class="mr-2">
        <app-select
          :data="{
            options: optionsCompanies,
            valueDefault: 'Empresa',
            required: true,
          }"
          v-model="companyId"
        />
      </b-col>
      <b-col cols="6" md="3" class="d-flex justify-content-center">
        <b-button variant="secondary" class="w-50" @click="cleanFn"
          >Limpar</b-button
        >

        <b-button variant="primary" class="ml-1 w-50" @click="getAllInformation"
          >Pesquisar</b-button
        >
      </b-col>
    </b-row>
    <app-cards-and-graph
      :graph="donutChart"
      :cards="indicators"
      @date="getDonutsGraph($event)"
      @clean="getDonutsGraph(defaultDate)"
    />
    <b-row>
      <b-col cols="12" v-for="(item, index) in acordeon" :key="index">
        <app-acordeon
          :optionsStatus="statusArray"
          :companies="optionsCompanies"
          :data="item"
          :rowsData="item.table['rows']"
          @keyword="setFilter('search', $event)"
          @perPage="setFilter('size', $event)"
          @currentPage="setFilter('page', $event)"
          @submit="submitForm($event)"
          @edit="editForm($event)"
          @reset="reset($event)"
          @remove="remove($event)"
        />
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import appCardsAndGraph from '@/components/lokiDashboard/_cardsAndGraph'
import api from '@/services/api'
import { mixins } from '@/mixins/mixins'
import fnGenerics from '@/mixins/loki/functions/generic'
import fnDomain from '@/mixins/loki/functions/domain'
import fnString from '@/mixins/loki/functions/string'
import fnChannels from '@/mixins/loki/functions/channels'
import fnLeaks from '@/mixins/loki/functions/leaks'
import fnAxur from '@/mixins/loki/functions/axur'
import fnVips from '@/mixins/loki/functions/vip'

import dataLoki from '@/mixins/loki/data'
import appAcordeon from '@/components/lokiDashboard/_accordeon'

export default {
  components: {
    appCardsAndGraph,
    appAcordeon,
  },
  mixins: [
    mixins,
    fnGenerics,
    fnDomain,
    fnString,
    fnChannels,
    dataLoki,
    fnLeaks,
    fnAxur,
    fnVips,
  ],
  beforeMount() {
    this.getAllInformation()
  },
  metaInfo: {
    title: 'Loki',
    titleTemplate: '',
  },

  methods: {
    async getAllInformation() {
      this.$store.commit('utils/setLoading', true)
      if (this.isAdmin) {
        await this.getCompanies()
      }
      await Promise.all([
        this.getStatusMonitoring(),
        this.getIndicators(),
        this.getDonutsGraph(this.defaultDate),
        this.getDomain(),
        this.getString(),
        this.getVips(),
        this.getChannels(),
        this.getAxurs(),
        this.getLeaks(),
      ])
      this.$store.commit('utils/setLoading', false)
    },

    async getDonutsGraph({ start, end }) {
      try {
        this.filter = Object.assign(this.filter, {
          idCompany: this.companyId,
          startDate: start,
          endDate: end,
        })
        const { data } = await api.getCounterLoki(this.filter)
        this.donutChart = data
      } catch (error) {
        this.errorCatch(error)
      }
    },

    async getStatusMonitoring() {
      try {
        const { data } = await api.getStatusLokiMonitoring()
        this.statusArray = Object.entries(data)
          .filter((ft) => !ft.includes('Scaneando'))
          .map(([, value]) => {
            return {
              value: value,
              text: value,
            }
          })
      } catch (error) {
        this.errorCatch(error)
      }
    },

    async getCompanies() {
      try {
        this.optionsCompanies = await api.getCompanies()
      } catch (error) {
        this.errorCatch(error)
      }
    },

    async getIndicators() {
      try {
        this.filter = Object.assign(this.filter, {
          idCompany: this.companyId,
        })
        const { data } = await api.getIndicatorsLoki(this.filter)
        this.indicators = Object.entries(data).map(([key, value]) => {
          return {
            number: value,
            title: this.getName(key).value,
            style: {
              backgroundColor: this.getName(key).color,
            },
            image: this.getName(key).image,
          }
        })
      } catch (error) {
        this.errorCatch(error)
      }
    },
  },
}
</script>
